import { SpecialtyViewModel } from '../../models/Entities/Specialties/SpecialtyModels';
import { CommonState } from '../common/state/commonState';

export interface SpecialtiesState extends CommonState<SpecialtyViewModel> {
    lastCreated?: SpecialtyViewModel;
}

export const SpecialtiesUnloadState: SpecialtiesState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
